import React, { useState, useContext } from 'react';
import ym from 'react-yandex-metrika';

import { Button, Main, Slider } from '@/components';
import { PageContext } from '@/Page';

import { defaultSlides } from './const';
import MacBook from './images/macBook.png';
import styles from './feedback.module.scss';

const Feedback: React.FC = () => {
  const { handleOpen, setCondition } = useContext(PageContext);
  const [activeSlide, setActiveSlide] = useState<number>(0);

  const handleNext = () => {
    if (activeSlide !== defaultSlides.length - 1) {
      setActiveSlide((prev) => prev + 1);
    } else {
      setActiveSlide(0);
    }
  };

  const handlePrev = () => {
    if (activeSlide !== 0) {
      setActiveSlide((prev) => prev - 1);
    } else {
      setActiveSlide(defaultSlides.length - 1);
    }
  };

  const handleSlide = (active: number) => setActiveSlide(active);

  const handleClick = () => {
    handleOpen();
    ym('reachGoal', 'leave_request_below');
    setCondition(4);
  };

  return (
    <div className={styles.container}>
      <Main>
        <h2 className={styles.container__title}>
          <span className={styles.container__title_info}>FIT FLEET</span> - это
          быстрое,
          <br /> прозрачное и безопасное <br /> обслуживание автопарка!
        </h2>
        <p className={styles.container__text}>
          Отзывы наших клиентов расскажут об этом лучше всего
        </p>
        <Slider
          items={defaultSlides}
          activeSlide={activeSlide}
          handleNext={handleNext}
          handlePrev={handlePrev}
          handleSlide={handleSlide}
        />
        <div className={styles.container__feedback}>
          <div className={styles.container__feedbackPart}>
            <h3 className={styles.container__feedbackTitle}>Хотите так же?</h3>
            <p className={styles.container__feedbackText}>
              Оставьте заявку, наш менеджер свяжется <br /> с вами в течение 1
              часа
            </p>
            <Button
              className={styles.container__feedbackBtn}
              variant='secondary'
              onClick={handleClick}
            >
              Оставить заявку
            </Button>
          </div>
          <div className={styles.container__feedbackPart}>
            <img
              className={styles.container__feedbackImg}
              src={MacBook}
              alt='MacBook'
            />
          </div>
        </div>
      </Main>
    </div>
  );
};

export default Feedback;
